<template>
	<div class="subnav">
		<template v-if="(size === 'sm' && activeTabs.length < 3) || (size === 'md' && activeTabs.length < 4)">
			<v-row no-gutters class="py-2 px-1">
				<v-col
					v-for="(tab, index) in activeTabs"
					:key="tab.name"
					class="px-1"
					:cols="activeTabs.length === 1 ? 12 : activeTabs.length === 2 ? 6 : 4">
					<v-btn
						small
						class=""
						:class="index === stickerTab ? 'active-tab-btn tab-btn' : 'tab-btn'"
						block
						@click="actions.setTab(index)">
						<img
							v-if="tab.icon"
							:src="require(`@/assets/icons/${tab.icon}.png`)"
							:alt="tab.name"
							class="mr-1" />
						{{ tab.name }}

						<template v-if="tab.isModified">
							<div class="exclamation">
								<v-icon size="12" color="white">{{ icons.exclamation }}</v-icon>
							</div>
						</template>
					</v-btn>
				</v-col>
			</v-row>
		</template>

		<template v-else>
			<div class="shadow-left" @mouseenter="actions.moveLeft"></div>
			<v-slide-group
				v-model="stickerTab"
				mandatory
				center-active
				@change="actions.setTab"
				class="px-4 py-2"
				id="slider"
				:show-arrows="true">
				<template #prev>
					<v-icon class="left-slide">{{ icons.mdiChevronLeft }}</v-icon>
				</template>
				<template #next>
					<v-icon class="right-slide">{{ icons.mdiChevronRight }}</v-icon>
				</template>
				<v-slide-item v-for="(tab, index) in activeTabs" :key="index" v-slot="{ active, toggle }">
					<v-btn
						small
						class="mx-1 px-3"
						:class="[active ? 'active-tab-btn tab-btn' : 'tab-btn', !tab.type && 'px-7']"
						@click="toggle">
						<img
							v-if="tab.icon"
							:src="require(`@/assets/icons/${tab.icon}.png`)"
							:alt="tab.name"
							class="mr-1" />
						{{ tab.name }}
					</v-btn>
				</v-slide-item>
			</v-slide-group>
			<div class="shadow-right" @mouseenter="actions.moveRight"></div>
		</template>
	</div>
</template>

<script>
import { ref, watch, computed } from 'vue';
import { mdiChevronLeft, mdiChevronRight, mdiExclamationThick } from '@mdi/js';
import { useStore } from '@/store';

export default {
	name: 'StickerSubNav',
	props: {
		tab: {
			type: Number,
			default: 0,
		},
	},
	setup(props, ctx) {
		const stickerTab = ref(0);
		const store = useStore();

		const size = computed(() => store.state.size);

		const activeTabs = computed(() => store.getters.activeTabItems);

		watch(
			() => props.tab,
			val => {
				stickerTab.value = val;
				actions.setTab(val);
			},
		);

		const actions = {
			setTab: function (value) {
				if (value || value === 0) {
					stickerTab.value = value;
				}
				ctx.emit('change', stickerTab.value);
			},
			moveLeft: function () {
				const slider = document.getElementsByClassName('left-slide')[0];
				slider.click();
			},
			moveRight: function () {
				const slider = document.getElementsByClassName('right-slide')[0];
				slider.click();
			},
		};

		return {
			size,
			stickerTab,
			// tabItems,
			activeTabs,
			actions,
			icons: {
				mdiChevronLeft,
				mdiChevronRight,
				exclamation: mdiExclamationThick,
			},
		};
	},
};
</script>

<style lang="scss" scoped>
.tab-btn {
	position: relative;
	.exclamation {
		position: absolute;
		width: 18px;
		height: 18px;
		border-radius: 50%;
		top: -12px;
		right: -18px;
		background: red;
		border: 1px solid black;
		color: white;
	}
}
</style>
